import jwtDecode from 'jwt-decode'
import { createRouter, createWebHistory } from 'vue-router'

import TeamView from '@/views/Dashboard/AdminOperator/TeamView.vue'
import BuyerView from '@/views/Dashboard/Buyer/BuyerView'
import DashboardView from '@/views/Dashboard/DashboardView.vue'
import FactoryView from '@/views/Dashboard/Factory/FactoryView.vue'
import DashboardOperator from '@/views/Dashboard/Operator/DashboardOperator.vue'
import ProductionView from '@/views/Dashboard/Production/ProductionView.vue'
import ReportsView from '@/views/Dashboard/Reports/ReportsView.vue'
import ReportView from '@/views/Dashboard/Requests/ReportView.vue'
import SupplierView from '@/views/Dashboard/Supplier/SupplierView.vue'
import RegisterView from '@/views/Register/RegisterView.vue'

const routes = [
  {
    path: '/',
    component: DashboardView,
    children: [
      {
        path: '/reports',
        name: 'reports',
        component: ReportsView,
        redirect: '/reports/current',
        meta: { team: 'admin' },
        children: [
          // {
          //   path: "/",
          //   name: "summary",
          //   alias: "/reports/summary",
          //   component: () => import(/* webpackChunkName: "summary" */ "@/views/Dashboard/Reports/SummaryView.vue")
          // },
          {
            // path: "/current",
            path: '/',
            name: 'current',
            alias: '/current',
            component: () => import(/* webpackChunkName: "current" */ '@/views/Dashboard/Reports/CurrentView.vue'),
          },
          {
            path: '/reports/history',
            name: 'history',
            component: () => import(/* webpackChunkName: "history" */ '@/views/Dashboard/Operator/OperatorView'),
          },
          {
            path: '/reports/history/:id',
            name: 'history-detail',
            component: () =>
              import(/* webpackChunkName: "history-detail" */ '@/views/Dashboard/Operator/OperationDetail'),
          },
          {
            path: '/reports/chart-tv',
            name: 'chart-tv',
            component: () => import(/* webpackChunkName: "chart-tv" */ '@/views/Dashboard/Reports/ChartTV.vue'),
          },
          {
            path: '/reports/analytics',
            name: 'analytics',
            component: () => import(/* webpackChunkName: "analytics" */ '@/views/Dashboard/Reports/AnalyticsChart.vue'),
          },
        ],
      },
      {
        path: '/factory',
        name: 'factory',
        redirect: '/factory/products',
        component: FactoryView,
        meta: { team: 'admin' },
        children: [
          {
            path: '/factory/products',
            name: 'products',
            component: () => import(/* webpackChunkName: "products" */ '@/views/Dashboard/Factory/ProductsView'),
          },
          {
            path: '/factory/integration',
            name: 'integration',
            component: () =>
              import(/* webpackChunkName: "integration" */ '@/views/Dashboard/Factory/IntegrationsView.vue'),
          },
          {
            path: '/factory/schedule',
            name: 'schedule',
            component: () => import(/* webpackChunkName: "schedule" */ '@/views/Dashboard/Factory/ScheduleView.vue'),
            redirect: '/factory/schedule/shift',
            children: [
              {
                path: '/factory/schedule/shift',
                name: 'shift',
              },
              {
                path: '/factory/schedule/timeline',
                name: 'timeline',
              },
            ],
          },
          {
            path: '/factory/watchers',
            name: 'watchers',
            component: () => import(/* webpackChunkName: "watchers" */ '@/views/Dashboard/Factory/WatchersView.vue'),
          },
          {
            path: '/factory/resources',
            name: 'recources',
            component: () => import(/* webpackChunkName: "recources" */ '@/views/Dashboard/Factory/ResourcesView.vue'),
          },
          {
            path: '/factory/ticket-issues',
            name: 'ticket-list',
            component: () => import(/* webpackChunkName: "ticket-list" */ '@/views/Dashboard/Factory/TicketIssues'),
          },
          {
            path: '/factory/payment',
            name: 'payment',
            component: () => import(/* webpackChunkName: "payment" */ '@/views/Dashboard/Factory/PaymentBilling'),
          },
          {
            path: '/factory/materials',
            name: 'raw-materials',
            component: () => import(/* webpackChunkName: "raw-materials" */ '@/views/Dashboard/Factory/RawMaterials'),
          },
          {
            path: '/factory/characteristics',
            name: 'characteristics',
            component: () =>
              import(/* webpackChunkName: "characteristics" */ '@/views/Dashboard/Factory/Characteristics'),
          },
          {
            path: '/factory/lines',
            name: 'production',
            component: () => import(/* webpackChunkName: "lines" */ '@/views/Dashboard/Production/ProductionLines.vue'),
          },
          {
            path: '/factory/lines/:line_id/:view',
            name: 'production-detail',
            component: () =>
              import(/* webpackChunkName: "production-detail" */ '@/views/Dashboard/Production/LineDetail'),
          },
          {
            path: '/factory/lines/manage-deactivated',
            name: 'deactivated',
            component: () =>
              import(/* webpackChunkName: "deactivated" */ '@/views/Dashboard/Production/ManageDeactivated'),
          },
          {
            path: '/factory/lines/manage-deactivated-operation',
            name: 'deactivated-operation',
            component: () =>
              import(
                /* webpackChunkName: "deactivated-operation" */ '@/views/Dashboard/Production/ManageDeactivatedOperation'
              ),
          },
          {
            path: '/factory/manage-deactivated-orders',
            name: 'deactivated-orders',
            component: () =>
              import(
                /* webpackChunkName: "deactivated-orders" */ '@/views/Dashboard/Production/ManageDeactivatedOrders'
              ),
          },
        ],
      },
      {
        path: '/orders',
        component: ProductionView,
        redirect: '/orders/shipments',
        meta: { team: 'admin' },
        children: [
          {
            path: '/orders/shipments',
            name: 'shipments',
            component: () => import(/* webpackChunkName: "shipments" */ '@/views/Dashboard/Production/Shipments'),
          },
          {
            path: '/orders/sales-orders',
            name: 'sales-orders',
            component: () => import(/* webpackChunkName: "sales-orders" */ '@/views/Dashboard/Production/SalesOrders'),
          },
          {
            path: '/orders/lots',
            name: 'orders',
            component: () => import(/* webpackChunkName: "orders" */ '@/views/Dashboard/Factory/SalesOrders'),
          },
        ],
      },
      {
        path: '/request',
        component: ReportView,
        redirect: '/request/list',
        meta: { team: 'admin' },
        children: [
          {
            path: '/request/list',
            name: 'request-list',
            component: () =>
              import(/* webpackChunkName: "report-request" */ '@/views/Dashboard/Requests/ReportRequests'),
          },
          {
            path: '/request/motion',
            name: 'request-motion',
            component: () => import(/* webpackChunkName: "operator-motion" */ '@/views/Dashboard/Motion/MotionStop'),
          },
          {
            path: '/request/motion/:id',
            name: 'request-motion-camera',
            component: () =>
              import(/* webpackChunkName: "operator-motion-camera" */ '@/views/Dashboard/Motion/MotionCamera'),
          },
          {
            path: '/request/counter',
            name: 'request-counter-color',
            component: () =>
              import(/* webpackChunkName: "counter-color" */ '@/views/Dashboard/Requests/CounterProduct'),
          },
          {
            path: '/request/ocr',
            name: 'request-ocr',
            component: () => import(/* webpackChunkName: "report-ocr" */ '@/views/Dashboard/Requests/ReportOcr'),
          },
          {
            path: '/request/template',
            name: 'request-template',
            component: () =>
              import(/* webpackChunkName: "report-template" */ '@/views/Dashboard/Requests/ReportTemplate'),
          },
        ],
      },
      {
        path: '/team-operator',
        redirect: '/admin-operators',
        component: TeamView,
        meta: { team: 'admin' },
        children: [
          {
            path: '/admin-operators',
            component: () =>
              import(/* webpackChunkName: "admin-operators" */ '@/views/Dashboard/AdminOperator/OperatorGroup.vue'),
            redirect: '/admin-operators/operators',
            children: [
              {
                path: '/admin-operators/operators',
                name: 'operators',
              },
              {
                path: '/admin-operators/groups',
                name: 'groups',
              },
              {
                path: '/admin-operators/level',
                name: 'level',
              },
            ],
          },
          {
            path: '/leader',
            name: 'leader',
            component: () => import(/* webpackChunkName: "leader" */ '@/views/Dashboard/Operator/LeaderBoard'),
          },
        ],
      },
      {
        path: '/operator',
        component: DashboardOperator,
        redirect: '/operator/current',
        meta: { team: 'operator' },
        children: [
          {
            path: '/current',
            name: 'operator',
            alias: '/operator/current',
            component: () => import(/* webpackChunkName: "operator" */ '@/views/Dashboard/Operator/OperatorView'),
          },
          {
            path: '/operator/current/:id',
            name: 'operator-operation-detail',
            component: () =>
              import(/* webpackChunkName: "operator-operation-detail" */ '@/views/Dashboard/Operator/OperationDetail'),
          },
          {
            path: '/operator/history',
            name: 'operator-history',
            component: () => import(/* webpackChunkName: "operator-history" */ '@/views/Dashboard/Reports/ChartTV.vue'),
          },
          {
            path: '/operator/chart-tv',
            name: 'operator-chart-tv',
            component: () =>
              import(/* webpackChunkName: "operator-chart-tv" */ '@/views/Dashboard/Reports/ChartTV.vue'),
          },
        ],
      },
      {
        path: '/operator/schedule',
        name: 'schedule_operator',
        component: () =>
          import(/* webpackChunkName: "schedule-operator" */ '@/views/Dashboard/Schedule/ScheduleOperator'),
        meta: { team: 'operator' },
      },
      {
        path: '/operator/report',
        component: ReportView,
        meta: { team: 'operator' },
        children: [
          {
            path: '/operator/report',
            name: 'report-request',
            component: () =>
              import(/* webpackChunkName: "report-request" */ '@/views/Dashboard/Requests/ReportRequests'),
          },
          {
            path: '/operator/motion',
            name: 'operator-motion',
            component: () => import(/* webpackChunkName: "operator-motion" */ '@/views/Dashboard/Motion/MotionStop'),
          },
          {
            path: '/operator/motion/:id',
            name: 'operator-motion-camera',
            component: () =>
              import(/* webpackChunkName: "operator-motion-camera" */ '@/views/Dashboard/Motion/MotionCamera'),
          },
          {
            path: '/operator/counter',
            name: 'counter-color',
            component: () =>
              import(/* webpackChunkName: "counter-color" */ '@/views/Dashboard/Requests/CounterProduct'),
          },
          {
            path: '/operator/ocr',
            name: 'ocr',
            component: () => import(/* webpackChunkName: "report-ocr" */ '@/views/Dashboard/Requests/ReportOcr'),
          },
          {
            path: '/operator/template',
            name: 'template',
            component: () =>
              import(/* webpackChunkName: "report-template" */ '@/views/Dashboard/Requests/ReportTemplate'),
          },
        ],
      },
      {
        path: '/operator/leader',
        name: 'leader-board',
        component: () => import(/* webpackChunkName: "leader-board" */ '@/views/Dashboard/Operator/LeaderBoard'),
        meta: { team: 'operator' },
      },
      {
        path: '/supplier',
        redirect: '/supplier/dashboard',
        component: SupplierView,
        meta: { team: 'supplier' },
        children: [
          {
            path: '/supplier/dashboard',
            name: 'supplier-dashboard',
            component: () =>
              import(/* webpackChunkName: "supplier-dashboard" */ '@/views/Dashboard/Supplier/SupplierDashboard'),
          },
          {
            path: '/supplier/detail',
            name: 'supplier-detail',
            component: () =>
              import(/* webpackChunkName: "supplier-detail" */ '@/views/Dashboard/Supplier/FactoryIssues'),
          },
        ],
      },
      {
        path: '/buyer',
        redirect: '/buyer/dashboard',
        component: BuyerView,
        meta: { team: 'buyer' },
        children: [
          {
            path: '/buyer/dashboard',
            name: 'buyer-dashboard',
            component: () => import(/* webpackChunkName: "buyer-dashboard" */ '@/views/Dashboard/Buyer/BuyerDashboard'),
          },
        ],
      },
    ],
  },
  {
    path: '/orders/graph',
    name: 'graph',
    component: () => import(/* webpackChunkName: "graph" */ '@/views/Dashboard/Production/OperationGraph'),
    meta: { team: 'admin' },
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: { type: 'register' },
    children: [
      {
        path: '/signup',
        name: 'signup',
        component: () => import(/* webpackChunkName: "signup" */ '@/views/Register/Pages/SignUp.vue'),
      },
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/Register/Pages/LogIn.vue'),
      },
      {
        path: '/forgot',
        name: 'forgot',
        component: () => import(/* webpackChunkName: "forgot" */ '@/views/Register/Pages/Forgot.vue'),
      },
      {
        path: '/check',
        name: 'check',
        component: () => import(/* webpackChunkName: "check" */ '@/views/Register/Pages/Check.vue'),
      },
      {
        path: '/reset',
        name: 'reset',
        component: () => import(/* webpackChunkName: "reset" */ '@/views/Register/Pages/Reset.vue'),
      },
      {
        path: '/order/:uuid',
        name: 'order',
        component: () => import(/* webpackChunkName: "order" */ '@/components/OrderBuyer'),
        meta: { team: 'global' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach(async (to) => {
  let user_info = localStorage.getItem('access') && jwtDecode(localStorage.getItem('access')).user_info
  if (user_info) {
    if (to.meta.team !== 'global') {
      if (user_info.is_admin && to.meta.team !== 'admin') return '/'
      else if (!user_info.is_admin && user_info.is_verify_operator && to.meta.team !== 'operator') return '/operator'
      else if (user_info.is_supplier && to.meta.team !== 'supplier') return '/supplier'
      else if (user_info.is_buyer && to.meta.team !== 'buyer') return '/buyer'
    }
  } else if (to.meta.team && to.meta.team !== 'register' && to.meta.team !== 'global') return '/login'
})

router.onError((error) => {
  console.error(error)
  if (/ChunkLoadError:.*failed./i.test(error.message)) {
    window.location.reload()
  } else if (/Loading.*chunk.*failed./i.test(error.message)) {
    window.location.reload()
  }
})

export default router
